/**
 * Shared Swiper init for listing product galleries (`.galleryslider.swiper[data-listing-product-gallery]`).
 * Used by product-listing and category-filter-section. Depends on Swiper from theme.liquid.
 * Bootstrap runs once even if the script tag appears on multiple sections.
 */
(function () {
  "use strict";
  if (window.__listingProductGallerySwiperBoot) return;
  window.__listingProductGallerySwiperBoot = true;

  function slideCount(container) {
    var w = container.querySelector(".swiper-wrapper");
    if (!w) return 0;
    return w.querySelectorAll(".swiper-slide").length;
  }

  function destroyListingGallerySwipersIn(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(".galleryslider.swiper[data-listing-product-gallery]").forEach(function (el) {
      if (el.swiper && typeof el.swiper.destroy === "function" && !el.swiper.destroyed) {
        el.swiper.destroy(true, true);
      }
      delete el.dataset.lpgSwiperInit;
    });
  }

  function initOne(container) {
    if (typeof Swiper === "undefined" || !container || !container.isConnected) return null;
    if (container.dataset.lpgSwiperInit === "1") return container.swiper || null;
    if (container.classList.contains("swiper-initialized")) {
      container.dataset.lpgSwiperInit = "1";
      return container.swiper || null;
    }
    if (slideCount(container) < 2) return null;

    container.dataset.lpgSwiperInit = "1";

    var enableAutoplay = container.getAttribute("data-listing-autoplay") === "true";

    var swiper = new Swiper(container, {
      wrapperClass: "swiper-wrapper",
      slideClass: "product-image-container",
      slidesPerView: 1,
      slidesPerGroup: 1,
      speed: 500,
      loop: true,
      autoplay: enableAutoplay
        ? {
            delay: 2000,
            disableOnInteraction: false,
          }
        : false,
      pagination: {
        el: container.querySelector(".swiper-pagination"),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"><button type="button"></button></span>';
        },
      },
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        991: { slidesPerView: 1 },
        768: { slidesPerView: 1 },
      },
    });

    if (enableAutoplay && "IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (swiper.autoplay) swiper.autoplay.start();
            } else {
              if (swiper.autoplay) swiper.autoplay.stop();
            }
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(container);
    }

    return swiper;
  }

  function initListingProductGallerySwipers(root) {
    root = root || document;
    root.querySelectorAll(".galleryslider.swiper[data-listing-product-gallery]").forEach(function (el) {
      initOne(el);
    });
  }

  window.initListingProductGallerySwipers = initListingProductGallerySwipers;

  function boot() {
    initListingProductGallerySwipers(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (ev) {
    var t = ev.target;
    if (!t || !t.querySelectorAll) return;
    destroyListingGallerySwipersIn(t);
    initListingProductGallerySwipers(t);
  });
})();
